import * as React from 'react';
import FormRow from '../../../../components/FormRow';
import FormSection from '../../../../components/FormSection';
import InputHandler from '../../../../components/InputHandler';
import { IFormContext, withFormContext } from 'Containers/FormContextHandler';

const AriaSymptomsForm = ({ editing, formData, fm }: IFormContext<IAriaSymptoms, IAriaSymptoms>): React.JSX.Element => {
  return (
    <React.Fragment>
      <FormSection>
        <FormRow title="general.date">
          <InputHandler
            type="PartialDate"
            editing={!!editing}
            name="date"
            formData={formData}
            isNotCancellable={true}
            dateDefault="now"
          />
        </FormRow>
        <FormRow title="ariaSymptoms.symptomsFound">
          <InputHandler
            type="Radio"
            editing={!!editing}
            name="symptomsFound"
            formData={formData}
            optionFormatter={o => fm(`general.${o}`)}
            options={['yes', 'no']}
            dependentFieldsList={o => ['symptoms']}
          />
        </FormRow>
        <FormRow title="ariaSymptoms.symptoms" condition={formData.document?.symptomsFound === 'yes'}>
          <InputHandler
            type="Checkbox"
            editing={!!editing}
            name="symptoms"
            formData={formData}
            optionFormatter={o => fm(`ariaSymptoms.opts.${o}`)}
            options={[
              'headache',
              'confusion',
              'nausea',
              'dizziness',
              'visualDisturbance',
              'balanceProblem',
              'seizures',
              'focalNeurologicalDeficits',
              'other',
            ]}
          />
        </FormRow>
        <FormRow title={'ariaSymptoms.additionalInformation'}>
          <InputHandler
            type="TextArea"
            editing={!!editing}
            name="additionalInformation"
            formData={formData}
            placeholder={'ariaSymptoms.additionalInformation'}
          />
        </FormRow>
      </FormSection>
    </React.Fragment>
  );
};

export default withFormContext(AriaSymptomsForm);
